import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actionsHome from '../../../../actions/process.home.actions';

import Grid from '@material-ui/core/Grid';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import BlueButton from '../../../buttons/BlueButton';
import Reference from './Reference';

const pagination = 15;

function sortData(arr, search) {
    if (!arr) {
        return arr;
    } else {
        const result = []
            .concat(arr)
            .sort((a, b) =>
                a.nombre.toUpperCase().trim() < b.nombre.toUpperCase().trim() ? -1 : 1,
            )
            .reduce((arr, info) => {
                if (search && search.length > 0) {
                    const filter = search.filter(
                        (s) => info.nombre && info.nombre.toUpperCase().includes(s),
                    );
                    if (filter && filter.length > 0) {
                        arr.push(<Reference key={randomstring()} reference={info} />);
                    }
                } else {
                    arr.push(<Reference key={randomstring()} reference={info} />);
                }
                return arr;
            }, []);
        return result;
    }
}

class ListReferences extends React.Component {
    state = {
        index: 0,
        references: sortData(this.props.references, this.props.window_searchs),
        window_searchs: this.props.window_searchs,
    };

    static getDerivedStateFromProps(props, state) {
        if (
            props.references !== state.references ||
            props.window_searchs !== state.window_searchs
        ) {
            state.window_searchs = props.window_searchs;
            state.references = props.references;
            state.data = sortData(props.references, props.window_searchs);
            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleClick = (event) => {
        this.setState({ index: this.state.index + pagination });
    };

    render() {
        const { index, data, references } = this.state;
        const { references_is_loading, references_has_errored } = this.props;
        const aux = [...data].splice(0, index + pagination);
        const length = data.length;

        if (references_has_errored.hasErrored) {
            return (
                <Error open type={references_has_errored.hasErrored}  message={references_has_errored.error} handleClose={this.handleBack} />
            );
        } else if (!references_is_loading && references === undefined) {
            return (
                <Error
                    open
                    message={<FormattedMessage id="error_references_not_found" />}
                    handleClose={this.handleBack}
                />
            );
        } else {
            return (
                <div className={'flex_full_column padding_bottom_9 padding_top_12 height100'}>
                    {references_is_loading && <Loading open opacity />}
                    <div className="flex_full overflow_y_scroll" onScroll={this.handleScroll}>
                        {aux.map((u) => {
                            return u;
                        })}
                        {length > index + pagination && (
                            <Grid
                                container
                                justify="center"
                                className={'flex_grow_1 align_center margin_top_24'}
                            >
                                <Grid item xs={10} sm={6} className="padding_bottom_12">
                                    <BlueButton id="next" onClick={this.handleClick} />
                                </Grid>
                            </Grid>
                        )}
                    </div>
                </div>
            );
        }
    }
}

ListReferences.propTypes = {
    references: PropTypes.array.isRequired,
    references_is_loading: PropTypes.bool.isRequired,
    references_has_errored: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        references: state.references,
        references_is_loading: state.references_is_loading,
        references_has_errored: state.references_has_errored,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actionsHome), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(ListReferences));



// WEBPACK FOOTER //
// ./src/components/complex/manage/references/List.js